module.exports = __webpack_public_path__ + "static/media/timetable-white.2495cf3c.svg";